module.exports = __webpack_public_path__ + "img/logo-theme-blue-dark.944d68f3.svg";